import React from 'react';
import { css } from '@linaria/atomic';
import { Row } from 'react-table';
import { CaretDownIconSmall } from '../../../../icon';
import { IconButton } from '../../../icon-button/icon-button.component';
import { TableData } from '../../table-data-type';

const rowExpandIconButtonStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const rowExpandCaretStyle = css`
  transition: transform 200ms ease-out;
  transform: var(--row-expand-caret-transform);
`;

type RowExpandedProps<T extends TableData> = {
  rowObject: Row<T>;
  isExpandableRowDisabled: boolean | undefined;
};

export const RowExpandCell = <T extends TableData>({ rowObject, isExpandableRowDisabled }: RowExpandedProps<T>) => {
  return (
    <IconButton
      disabled={!!rowObject?.isDisabled || !!isExpandableRowDisabled}
      color='light'
      className={rowExpandIconButtonStyle}
      size='small'
      label={rowObject.isExpanded ? 'Condense row' : 'Expand row'}
    >
      <CaretDownIconSmall
        className={rowExpandCaretStyle}
        style={
          {
            '--row-expand-caret-transform': rowObject.isExpanded ? `rotate(180deg)` : null,
          } as React.CSSProperties
        }
        color='light'
        size={16}
      />
    </IconButton>
  );
};
